import { FC, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { ComplementForms } from '../Requests/components/ComplementForms';
import { RequestsFormValues } from '../Requests/models';
import { ApiComplementType, mapDataToFormValues } from '../shared/labRequestTypes';
import { ReadOnlyOverlay } from './styles';

type Props = {
  type: ApiComplementType;
  data: any;
};

export const ReadOnlyLabRequestForm: FC<Props> = ({ type, data }) => {
  const defaultValues = useMemo(() => mapDataToFormValues(type, data), [type, data]);

  const methods = useForm<RequestsFormValues>({
    defaultValues: defaultValues as RequestsFormValues
  });

  return (
    <FormProvider {...methods}>
      <ReadOnlyOverlay>
        <ComplementForms />
      </ReadOnlyOverlay>
    </FormProvider>
  );
};
